import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from '@themesberg/react-bootstrap';
import { FaEdit, FaFilePdf, FaRedo } from 'react-icons/fa';
import DirectionPathButton from '../widgets/directionPathButton';

/**
 * ReportActions:
 * Renders modern icon-only buttons with tooltips in V2,
 * and maintains classic text buttons in V1.
 */
export default function ReportActions({
  // Modify / Edit
  showModify = false,
  modifyDisabled = false,
  modifyPath = '',
  onModify,

  // PDF
  showPdf = false,
  pdfDisabled = false,
  onPdf,

  // Re-open (reabrir)
  showReopen = false,
  reopenDisabled = false,
  onReopen,

  // Custom Extra Actions
  extraActions,
}) {
  const version = useSelector((state) => state.uiVersion?.version || 'v2');
  const navigate = useNavigate();

  const handleModify = () => {
    if (onModify) onModify();
    else if (modifyPath) navigate(modifyPath);
  };

  // V2: Apple-inspired compact icon-only action group
  if (version === 'v2') {
    return (
      <div className="v2-action-group" style={{ display: 'inline-flex', gap: '6px', alignItems: 'center' }}>
        {showModify && (
          <button
            type="button"
            className="v2-action-btn v2-action-edit"
            disabled={modifyDisabled}
            onClick={handleModify}
            title="Modificar peritaje"
            aria-label="Modificar peritaje"
          >
            <FaEdit />
          </button>
        )}

        {showPdf && (
          <button
            type="button"
            className="v2-action-btn v2-action-pdf"
            disabled={pdfDisabled}
            onClick={onPdf}
            title="Ver reporte en PDF"
            aria-label="Ver reporte en PDF"
          >
            <FaFilePdf />
          </button>
        )}

        {showReopen && (
          <button
            type="button"
            className="v2-action-btn v2-action-reopen"
            disabled={reopenDisabled}
            onClick={onReopen}
            title="Re-Abrir peritaje"
            aria-label="Re-Abrir peritaje"
          >
            <FaRedo />
          </button>
        )}

        {extraActions}
      </div>
    );
  }

  // V1: Classic layout with text buttons
  return (
    <Row className="gx-1">
      {showModify && (
        <Col xs="auto">
          <DirectionPathButton
            disabled={modifyDisabled}
            text="Modificar"
            path={modifyPath}
            variant="outline-primary"
          />
        </Col>
      )}

      {showPdf && (
        <Col xs="auto">
          <Button
            disabled={pdfDisabled}
            onClick={onPdf}
            variant="outline-primary"
            size="sm"
          >
            Ver PDF
          </Button>
        </Col>
      )}

      {showReopen && (
        <Col xs="auto">
          <Button
            disabled={reopenDisabled}
            onClick={onReopen}
            variant="outline-success"
            size="sm"
          >
            Re-Abrir
          </Button>
        </Col>
      )}

      {extraActions && <Col xs="auto">{extraActions}</Col>}
    </Row>
  );
}
